import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { RootState } from '../rootState'
import { Todo } from '../../types/Todo'

const initialState = {
  todos: [],
}

interface TodoState {
  todos: Todo[]
}

const sortTodos = (a: Todo, b: Todo): number => {
  if (a.timestamp > b.timestamp) {
    return -1
  } else if (a.timestamp < b.timestamp) {
    return 1
  } else {
    return 0
  }
}

const slice = createSlice({
  name: 'todo',
  initialState,
  reducers: {
    prepend: (state: TodoState, action: PayloadAction<Todo>) => {
      state.todos = [action.payload, ...state.todos]
    },
    append: (state: TodoState, action: PayloadAction<Todo[]>) => {
      const temp: Todo[] = [...state.todos, ...action.payload]
      const tempTodos = temp.filter((e, p, self) => {
        const ids = self.map((e) => e.id)
        return ids.indexOf(e.id) === p
      })

      state.todos = tempTodos.sort(sortTodos)
    },
    set: (state: TodoState, action: PayloadAction<Todo[]>) => {
      state.todos = action.payload
    },
    update: (state: TodoState, action: PayloadAction<Todo>) => {
      const found = state.todos.find((ele) => ele.id === action.payload.id)
      if (!found) {
        return
      }
      const filtered = state.todos.filter((ele) => ele.id !== action.payload.id)
      filtered.push(action.payload)
      state.todos = filtered.sort(sortTodos)
    },
    delete: (state: TodoState, action: PayloadAction<string | undefined>) => {
      if (action.payload === undefined) {
        return
      }
      const found = state.todos.find((ele) => ele.id === action.payload)
      if (!found) {
        return
      }
      state.todos = state.todos.filter((ele) => ele.id !== action.payload)
    },
    setOneItemActive: (state: TodoState, action: PayloadAction<Todo>) => {
      const found = state.todos.find((ele) => ele.id === action.payload.id)
      if (!found) {
        return
      }
      const copied = state.todos.slice()
      copied.forEach((ele) => {
        if (ele.id === found.id) {
          ele.isActive = true
        } else {
          ele.isActive = false
        }
      })
      state.todos = [...copied]
    },
  },
})

export const useTodos = (): Todo[] =>
  useSelector((state: RootState) => state.todo.todos)

export const TODO_STORE_NAME = slice.name
export const TodosActions = slice.actions
export default slice.reducer
